/**
 * features/products/use-product-search.ts — ค้นหาสินค้าแบบ autocomplete สำหรับใช้ในฟอร์มเอกสาร
 */

import { useQuery } from '@tanstack/react-query';
import { api, queryString } from '~/lib/api';
import type { Paginated, Product } from '~/lib/types';

export function useProductSearch(search: string) {
  return useQuery({
    queryKey: ['products', 'search', search],
    queryFn: () =>
      api.get<Paginated<Product>>(
        `/api/products${queryString({ page: 1, pageSize: 8, search })}`,
      ),
    enabled: search.trim().length > 0,
  });
}
